<p class="intro-text">Please select a cohort, and enter a value for the random sample percentage.</p>
<div class="row">
  <div class="col-md-6">
    <div class="form-group">
      <label>Cohort</label>
      <mat-select class="form-control" [(ngModel)]="renewalDate">
        @for (item of samplings; track item) {
          <mat-option [value]="item.renewalDate">
            {{ item.renewalDate | date: 'dd/MM/yyyy' }}
            ({{ item.revalidationCount }} submissions)
          </mat-option>
        }
      </mat-select>
    </div>
  </div>
  <div class="col-md-6">

    <div class="form-group">
      <label>Random sample percentage</label>
      <input style="width: 80px" type="number" [(ngModel)]="percentage" class="form-control" />
    </div>
  </div>
</div>
<button (click)="generate()" [disabled]="generating" class="mt-4 btn btn-lg btn-block btn-primary">
  @if (!generating) {
    <span>
      Select for review
    </span>
  }

  @if (generating) {
    <span style="display:flex;align-items:center">
      <div style="flex-grow:1"></div>
      <app-spinner [tiny]="true" [light]="true"></app-spinner>&nbsp;&nbsp;Selecting for review...
      <div style="flex-grow:1"></div>
    </span>
  }

</button>